import { AccordionBlock, ContentBlockType } from '../../../model';

export const ACCORDION_NODE_NAME = 'accordion';
export const ACCORDION_PANEL_NODE_NAME = 'accordionPanel';

export const DEFAULT_ACCORDION_PANEL_TITLE = 'New Panel';

export const DEFAULT_ACCORDION_PROPS = {
  type: ContentBlockType.Accordion,
  panels: [{ title: 'Panel 1', content: [] }],
} as const satisfies Partial<AccordionBlock>;
